import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const RouteProtected = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();
  const token = localStorage.getItem("token");

  // If the current route is /auth/login, render children without checking token  
  if (location.pathname === '/auth/login') {
    return children;
  }

  if (!token) {
    return <Navigate to="/auth/login" replace />;
  }
  return children;
};

export default RouteProtected;